import { UserProfileState } from '@bd/store-modules/types/userProfile'
import { getDefaultUserObject } from './utils'

export const state: UserProfileState = {
  user: getDefaultUserObject(),
}
